import { useEffect } from "react";
import { useProgress } from "@react-three/drei";
import { useLoadingStore } from "../lib/LoadingStore/loadingStore.ts";

/**
 * Watches R3F scene load progress and drives the global loading state.
 * Mount once at the app root (inside a Canvas context or alongside one).
 */
export const useSceneLoading = () => {
  const { progress } = useProgress();
  const setIsLoading = useLoadingStore((state) => state.setIsLoading);

  useEffect(() => {
    if (progress === 100) {
      const timer = setTimeout(() => setIsLoading(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [progress, setIsLoading]);
};
